import { connect } from "react-redux";
import { PageAppointments } from "senac-components";
import { RootState, AppDispatch } from "../store";
import {
  ContentFilters,
  ContentHeaderOptionItem,
  MenuOptions,
  PageHeaderOptionItem
} from "senac-components/dist/pages/Mobile/PageInterfaces";
import { commonSlice, contentSlice } from "../store/reducers";
import { OptionsItems, PageAppointmentsDispatchProps, PageAppointmentsStateProps } from "senac-components/dist/pages/Mobile/PageAppointments";
import { filterContent } from "../store/reducers/common";

const mapState = (state: RootState) => 
{
  var pdfdata:OptionsItems[] | undefined = undefined;
  var epubdata:OptionsItems[] | undefined = undefined;
  var activeContent = state.contentState.allContents.find(p=> p.uid == state.contentState.activeContentUid);
  var data = state.userDataState.userData.filter(p=> p.targetType == "ManagedContentReference" && p.contextType == "ManagedContent" && p.contextUid == activeContent?.uid);

  data.forEach(userData=>
  {
    var reference = activeContent?.references?.find(r=> r.uid == userData.targetUid);
    if (!reference) return;

    var option: OptionsItems = 
    {
      uid: userData.uid,
      title: userData.description,
      marked: userData.annotation,
      numerReading : "0"
    }


    try{
      var info = JSON.parse(userData.externalData);
      // console.log("info:", info);
      option.numerReading = info.chapter_index;
      option.markColor = info.mark_color;

    }catch(e){

    }

    switch(reference.mimeType)
    {
      case 'application/epub+zip':
        {
          if (!epubdata) epubdata = [];
          epubdata.push(option);
          break;
        }
        case 'digitalpages/richpack':
          {
            if (!pdfdata) pdfdata = [];
            pdfdata.push(option);
            break;
          }
    }
  })


  let result: PageAppointmentsStateProps = 
  {
    content: activeContent,
    pdfAppointments: pdfdata,
    epubAppointments: epubdata
  };

  return result;
};

const mapDispatch = (dispatch: AppDispatch) => 
{
  const result: PageAppointmentsDispatchProps = 
  {
    onChangeFilter: (filter:ContentFilters) => {
      if (filter.query == undefined) return;
      dispatch(filterContent({ query: filter.query }));
    },
    onSelectedHeaderBack: () => dispatch(commonSlice.actions.backPage()),
    onSelectedHeaderMenuOption: (option: ContentHeaderOptionItem) => dispatch(contentSlice.actions.goToContentInfo(option)),
    // onSelectedHeaderMenuOption: (option: PageHeaderOptionItem) => dispatch(commonSlice.actions.goToPageOption(option)),
    onSelectedNavigationPageOption: (option: MenuOptions) => dispatch(commonSlice.actions.goToPage(option)),

  };

  return result;
};

const WPageAppointments = connect(
  mapState,
  mapDispatch
)(PageAppointments);

export { WPageAppointments };
